var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPk = function SvgPk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M0 12c0 4.549 2.53 8.506 6.26 10.541V1.46A11.997 11.997 0 0 0 0 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M12 0C9.92 0 7.966.53 6.26 1.46v21.082C7.967 23.472 9.922 24 12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M17.13 13.986a3.391 3.391 0 1 1-2.425-6.112 4.174 4.174 0 1 0 3.495 4.837 3.376 3.376 0 0 1-1.07 1.275ZM17.066 7.827l.855.922 1.14-.529-.611 1.098.855.922-1.234-.243-.612 1.098-.15-1.248-1.234-.243 1.141-.529-.15-1.248Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgPk;